(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/theme-day-by-date.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/theme-day-by-date.js');
"use strict";

const {
  VariableSizeList,
  areEqual
} = ReactWindow;
const {
  DATE_AND_TIME
} = svs.tickets_giftshop.constants.names;
const {
  themeDaysSubSet
} = svs.tickets_giftshop.constants;
const {
  useRef,
  useEffect,
  useCallback,
  useMemo,
  memo
} = React;
const {
  mapMonthByNumber,
  isNextYear,
  sortDateData,
  aggregateDateData,
  formatDate
} = svs.tickets_giftshop.gift.giftform.date_selector.components.util;
const {
  THEME_DAY_BY_DATE
} = svs.tickets_giftshop.constants.dateSelectorKey;
const DayMonthList = _ref => {
  let {
    day,
    month,
    names,
    year
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("div", null, React.createElement("b", null, "".concat(day, " ").concat(mapMonthByNumber(month).toLowerCase(), " ").concat(year === new Date().getFullYear() ? '' : "(".concat(new Date().getFullYear() + 1, ")")))), React.createElement("ul", {
    className: "padding-left-1"
  }, names.map(name => React.createElement("li", {
    key: "".concat(name, "_").concat(day),
    style: {
      listStyle: 'disc'
    }
  }, name))));
};
const Row = memo(_ref2 => {
  let {
    index,
    data,
    style
  } = _ref2;
  const classNames = ['tg-theme-day-by-date-row-item'];
  const {
    items,
    selectDate,
    isActive,
    isNextYear
  } = data;
  const item = items[index];
  const [month, day] = item.date.split('-');
  const names = (item === null || item === void 0 ? void 0 : item.names) || [];
  const thisYear = new Date().getFullYear();
  const year = isNextYear(day, month) ? thisYear + 1 : thisYear;
  const active = isActive(day, month, year);
  if (active) {
    classNames.push('tg-theme-by-day-selected fc-white');
  } else {
    classNames.push('fc-black');
  }
  return React.createElement("div", {
    className: "tg-theme-day-by-date-row",
    style: style
  }, React.createElement("a", {
    className: classNames.join(' '),
    href: "",
    onClick: e => {
      e.preventDefault();
      selectDate(day, month, year);
    }
  }, React.createElement(DayMonthList, {
    day: day,
    month: month,
    names: names,
    year: year
  })));
}, areEqual);
const ThemeDayByDate = _ref3 => {
  let {
    date,
    dateData,
    onInputChange,
    minDate = svs.utils.date.SimpleDate(new Date()),
    maxDate = svs.utils.date.SimpleDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1)))
  } = _ref3;
  const listRef = useRef(null);
  const selectDate = useCallback((day, m, year) => {
    const date = formatDate(day, m, year);
    onInputChange({
      target: {
        value: {
          date,
          time: '08:00',
          dateSelectorUsed: THEME_DAY_BY_DATE
        },
        name: DATE_AND_TIME
      }
    });
  }, [formatDate, onInputChange]);
  const data = useMemo(() => {
    const sortedDateData = sortDateData(aggregateDateData(dateData, themeDaysSubSet));
    return {
      itemsCount: sortedDateData.length,
      items: sortedDateData || [],
      selectDate,
      isActive: (day, month, year) => formatDate(day, month, year) === date,
      isNextYear
    };
  }, [date, formatDate, selectDate, minDate, maxDate]);
  useEffect(() => {
    if (listRef.current && data.items) {
      const chosenIndex = data.items.findIndex(obj => {
        const [month, day] = obj.date.split('-');
        const isNextYear = minDate > formatDate(day, month, new Date().getFullYear());
        const year = new Date().getFullYear();
        return date === formatDate(day, month, isNextYear ? year + 1 : year);
      }) || 0;
      listRef.current.scrollToItem(chosenIndex - 1, 'center');
    }
  }, []);
  const calcItemSize = useCallback(index => {
    var _items$index;
    const {
      items
    } = data;
    const numberOfItems = (_items$index = items[index]) === null || _items$index === void 0 ? void 0 : _items$index.names.length;
    return 36 + numberOfItems * 18;
  }, [data]);
  return React.createElement("div", {
    className: "tg-date-input gutter-sm-2"
  }, React.createElement(VariableSizeList, {
    className: "List tg-date-selector-inverted-box-shadow",
    height: 360,
    itemCount: data.itemsCount,
    itemData: data,
    itemSize: calcItemSize,
    layout: "vertical",
    ref: listRef
  }, Row));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.ThemeDayByDate = ThemeDayByDate;

 })(window);